import React, { Component} from "react";
import Head from "../components/Head";

export default class NoPage extends Component{
        render(){
          return(
            <div>
            <Head />
            <h1>No Page Here</h1>
                  </div>
          );
        }
}